import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import chakraTheme from "./constants/chakraTheme";
import Routes from "./Routes";
import "focus-visible/dist/focus-visible";
import { isQA } from "./utils/domainUtils";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
TimeAgo.addDefaultLocale(en);

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = isQA()
  ? {
      apiKey: "AIzaSyA4ANPkA8sLwhEtKzdldu-vaRuJTArDlz0",
      authDomain: "qa-globalentrysentry.firebaseapp.com",
      databaseURL: "https://qa-globalentrysentry.firebaseio.com",
      projectId: "qa-globalentrysentry",
      storageBucket: "qa-globalentrysentry.appspot.com",
      messagingSenderId: "853399809856",
      appId: "1:853399809856:web:cfa2cbb0fdcdb8ed7594a5",
      measurementId: "G-5TWBTGHLT7",
    }
  : {
      apiKey: "AIzaSyCxR5OtwmIxEAUwIyvj08pe9YMrzSK2fPo",
      authDomain: "appointmentscanner.com",
      databaseURL: "https://globalentrysentry.firebaseio.com",
      projectId: "globalentrysentry",
      storageBucket: "globalentrysentry.appspot.com",
      messagingSenderId: "844123184736",
      appId: "1:844123184736:web:2ee28983fd2cc0a6d7ad05",
      measurementId: "G-ZDPNEXFVV3",
    };

initializeApp(firebaseConfig);
const analytics = getAnalytics();

export default function App() {
  return (
    <ChakraProvider theme={chakraTheme}>
      <Routes />
    </ChakraProvider>
  );
}
